import spaceStyle, { type SpacingProps } from '@/styles/space'
import textAlign from '@/styles/text_align'
import { V1FormElementUiType, type V1FormElement } from 'mnvm-mypage-app-ts-if'
import { Text3 } from '../base/Text'
import _ from 'lodash'
import useIsMobile from '@/hooks/useMobile'
import { type FontSizeKeyType, fontSize } from '@/styles/font'

export const isFormElementNoInputHiddenOnView = (
  elements: V1FormElement[]
): boolean => {
  return (
    elements.length > 0 &&
    _.every(elements, (element) => {
      return (
        element.uiType === V1FormElementUiType.NoInput &&
        !(element.isLabelVisibleOnView ?? false)
      )
    })
  )
}

interface FormElementNoInputProps {
  formElement: V1FormElement
  isShowLabelOnView: boolean
  isShowLabelOnEdit: boolean
  margin?: SpacingProps
  size?: FontSizeKeyType
}

const FormElementNoInput = ({
  formElement,
  isShowLabelOnView,
  isShowLabelOnEdit,
  margin,
  size
}: FormElementNoInputProps): JSX.Element => {
  const isMobile = useIsMobile()

  return (
    <>
      {formElement?.label !== undefined &&
        (isShowLabelOnView || isShowLabelOnEdit) && (
          <Text3
            margin={
              margin ?? {
                vertical: spaceStyle.NONE,
                right: spaceStyle.NONE,
                left: spaceStyle.XXS
              }
            }
            textAlign={textAlign.LEFT}
            fontSize={size ?? (isMobile ? fontSize.XS : fontSize.S)}
          >
            {formElement.label}
          </Text3>
        )}
    </>
  )
}

export default FormElementNoInput
